module.exports = __webpack_public_path__ + "static/gallery-18-61e25c2ce3b8ba0b1a8547a59d5a459c.jpeg";